import React from "react";
import { useSelector } from "react-redux";
import { CardPrices } from "../../reusableUI/v2UI/CardsPrices";

export const BoxTotals = ({ totals }) => {
  const {
    local_separacion_miles: separacion_miles,
    local_separacion_decimales: separacion_decimales,
    local_simbolo: simbolo,
  } = useSelector((state) => state.general.info);

  /* console.log({ totals }); */
  /* const { facturado = 0, cobrado = 0, por_cobrar = 0 } = totals; */

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 lg:grid-cols-3 mt-3">
      <CardPrices
        title="TOTAL FACTURADO"
        total={totals?.facturado || 0}
        percent={0}
        label="Monto total"
        bgColor="bg-orange-600"
        textColor="text-orange-600"
        formatMoney={{
          thousandSeparator: separacion_miles || ",",
          decimalSeparator: separacion_decimales || ".",
          prefix: simbolo || "S/",
        }}
        hasProgress={false}
      />

      <CardPrices
        title="COBRADO"
        total={totals?.cobrado || 0}
        percent={
          totals?.cobrado
            ? (parseFloat(totals?.cobrado) / parseFloat(totals?.facturado)) *
              100
            : 0
        }
        label="de lo facturado"
        bgColor="bg-green-600"
        textColor="text-green-600"
        formatMoney={{
          thousandSeparator: separacion_miles || ",",
          decimalSeparator: separacion_decimales || ".",
          prefix: simbolo || "S/",
        }}
      />

      <CardPrices
        title="POR COBRAR"
        total={totals?.por_cobrar || 0}
        percent={
          totals?.por_cobrar
            ? (parseFloat(totals?.por_cobrar) / parseFloat(totals?.facturado)) *
              100
            : 0
        }
        label="pendiente"
        bgColor="bg-red-600"
        textColor="text-red-600"
        formatMoney={{
          thousandSeparator: separacion_miles || ",",
          decimalSeparator: separacion_decimales || ".",
          prefix: simbolo || "S/",
        }}
      />
    </div>
  );
};
